import { useEffect, useState } from "react";
import { Button, Card, Typography, Divider, Form, Select, Flex, Checkbox, InputNumber } from "antd";
import { LeftOutlined, MinusOutlined, PlusOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import { changeLoader } from "../../../redux/reducers/loader";
import { useDispatch } from "react-redux";
import globalRequest from "../../../utils/global/globalRequest";
import * as Apis from "../../../utils/helper/enum";
import toast from "react-hot-toast";
import { selectTime } from "../../../utils/helper/constants";

const daysName = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

const EditBranchFastestHours = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  let { id, branchId } = useParams();

  const initialTimeSlot = {
    openTime: null,
    closeTime: null,
    capacity: null,
    openTimeErr: null,
    closeTimeErr: null,
    capacityErr: null,
  };
  const [timeSlots, setTimeSlots] = useState({
    1: [initialTimeSlot], // Sunday
    2: [initialTimeSlot], // Monday
    3: [initialTimeSlot], // Tuesday
    4: [initialTimeSlot], // Wednesday
    5: [initialTimeSlot], // Thursday
    6: [initialTimeSlot], // Friday
    7: [initialTimeSlot], // Saturday
  });

  const [edit, setEdit] = useState(false);

  const handleAddSlot = (day) => {
    const newSlots = { ...timeSlots };
    newSlots[day].push({ ...initialTimeSlot });
    setTimeSlots(newSlots);
  };

  const handleRemoveSlot = (day, index) => {
    const newSlots = { ...timeSlots };
    if (newSlots[day].length > 1) {
      newSlots[day].splice(index, 1);
      setTimeSlots(newSlots);
    }
  };

  const handleTimeChange = (day, index, field, value) => {
    if (field === "isChecked") {
      const updatedSlots = timeSlots[day].map((slot, slotIndex) => {
        if (slotIndex === index) {
          return { ...slot, [field]: value };
        }
        return slot;
      });
      setTimeSlots({
        ...timeSlots,
        [day]: updatedSlots,
      });
    } else {
      const updatedSlots = timeSlots[day].map((slot, slotIndex) => {
        if (slotIndex === index) {
          return { ...slot, [field]: value, [`${field}Err`]: null };
        }
        return slot;
      });
      setTimeSlots({
        ...timeSlots,
        [day]: updatedSlots,
      });
    }
  };

  const validateSlots = () => {
    let hasError = false;
    const newSlots = { ...timeSlots };

    Object.keys(newSlots).forEach((day) => {
      const daySlots = newSlots[day];

      // Validate each slot
      daySlots.forEach((slot, index) => {
        if (slot.openTime && slot.closeTime && slot.openTime >= slot.closeTime) {
          newSlots[day][index].closeTimeErr = "Close time must be greater than open time.";
          hasError = true;
        }
      });
    });

    setTimeSlots(newSlots);
    return !hasError;
  };

  const goBack = () => {
    localStorage.setItem("currentTab", "3");
    navigate(`/edit-branch/${id}/${branchId}`);
  };

  const handleSubmit = async () => {
    if (!validateSlots()) return;

    let time_slots = [];

    for (let i in timeSlots) {
      if (timeSlots[i].length > 0) {
        let slots = [];
        for (let j in timeSlots[i]) {
          slots.push({
            openTime: timeSlots[i][j].openTime,
            closeTime: timeSlots[i][j].closeTime,
            capacity: timeSlots[i][j].capacity,
          });
        }
        time_slots.push({
          day: daysName[i - 1].toLowerCase(),
          slots: slots,
        });
      }
    }

    let insertArray = {
      branchId: branchId,
      time_slots: time_slots,
    };
    dispatch(changeLoader(true));
    try {
      let url = Apis?.FASTEST_TIME_SLOTE?.CREATE_TIME_SLOTE;
      let method = "post";
      if (edit) {
        url = Apis?.FASTEST_TIME_SLOTE?.EDIT_TIME_SLOTE;
        method = "put";
      }
      let response = await globalRequest(url, method, insertArray, {}, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let msg = "Fastest working hours added successfully";
        if (id) msg = "Fastest working hours updated successfully";
        toast.success(msg, {
          duration: 2000,
        });
        goBack();
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  const getTimeSlotes = async (id) => {
    let params = {
      id: branchId,
      type: "day",
    };
    try {
      let response = await globalRequest(Apis.FASTEST_TIME_SLOTE.GET_ALL_TIME_SLOTE, "get", {}, { params: params }, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        if (!apiResponse?.data) setEdit(false);
        else {
          setEdit(true);
          let data = apiResponse?.data?.data;

          let sunday = [];
          let monday = [];
          let tuesday = [];
          let wednesday = [];
          let thursday = [];
          let friday = [];
          let saturday = [];
          for (let i in data) {
            if (data[i].day === "sunday")
              sunday.push({
                openTime: data[i].openTime,
                closeTime: data[i].closeTime,
                openTimeErr: null,
                closeTimeErr: null,
                capacity: data[i].capacity,
                capacityErr: null,
              });
            if (data[i].day === "monday")
              monday.push({
                openTime: data[i].openTime,
                closeTime: data[i].closeTime,
                openTimeErr: null,
                closeTimeErr: null,
                capacity: data[i].capacity,
                capacityErr: null,
              });
            if (data[i].day === "tuesday")
              tuesday.push({
                openTime: data[i].openTime,
                closeTime: data[i].closeTime,
                openTimeErr: null,
                closeTimeErr: null,
                capacity: data[i].capacity,
                capacityErr: null,
              });
            if (data[i].day === "wednesday")
              wednesday.push({
                openTime: data[i].openTime,
                closeTime: data[i].closeTime,
                openTimeErr: null,
                closeTimeErr: null,
                capacity: data[i].capacity,
                capacityErr: null,
              });
            if (data[i].day === "thursday")
              thursday.push({
                openTime: data[i].openTime,
                closeTime: data[i].closeTime,
                openTimeErr: null,
                closeTimeErr: null,
                capacity: data[i].capacity,
                capacityErr: null,
              });
            if (data[i].day === "friday")
              friday.push({
                openTime: data[i].openTime,
                closeTime: data[i].closeTime,
                openTimeErr: null,
                closeTimeErr: null,
                capacity: data[i].capacity,
                capacityErr: null,
              });
            if (data[i].day === "saturday")
              saturday.push({
                openTime: data[i].openTime,
                closeTime: data[i].closeTime,
                openTimeErr: null,
                closeTimeErr: null,
                capacity: data[i].capacity,
                capacityErr: null,
              });
          }

          setTimeSlots({
            1: [...sunday], // Sunday
            2: [...monday], // Monday
            3: [...tuesday], // Tuesday
            4: [...wednesday], // Wednesday
            5: [...thursday], // Thursday
            6: [...friday], // Friday
            7: [...saturday], // Saturday
          });
        }
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };

  useEffect(() => {
    getTimeSlotes(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Card>
        <div className="">
          <Typography className="text-xl font-semibold" align={"left"}>
            <LeftOutlined className="mr-2" onClick={() => goBack()} />
            Add Fastest Working hours
          </Typography>
        </div>
        <Divider />
        <div className="min-h-[calc(100vh_-_305px)]">
          <Form
            layout="vertical"
            initialValues={{
              remember: true,
            }}
            autoComplete="off"
          >
            {Object.keys(timeSlots).map((day) => (
              <div key={day}>
                <Flex gap="middle" className="w-full ">
                  <div className="grid grid-cols-4 items-start">
                    <Checkbox
                      checked={timeSlots[day]?.length}
                      onChange={(e) => {
                        if (timeSlots[day]?.length) {
                          setTimeSlots((prev) => ({
                            ...prev,
                            [day]: [],
                          }));
                        } else {
                          setTimeSlots((prev) => ({
                            ...prev,
                            [day]: [initialTimeSlot],
                          }));
                        }
                      }}
                    >
                      {daysName[day - 1]}
                    </Checkbox>
                    <div className="flex flex-col gap-4">
                      {timeSlots[day]?.map((slot, index) => (
                        <div key={index} className="flex gap-4 ">
                          <div className="w-full">
                            <Select
                              size="large"
                              placeholder="Select"
                              options={selectTime}
                              showSearch
                              filterOption={(input, selectTime) => (selectTime?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                              onChange={(value) => {
                                handleTimeChange(day, index, "openTime", value);
                              }}
                              value={slot.openTime}
                              className="w-[200px]"
                            />
                            {slot.openTimeErr && <span className="text-red-100">{slot.openTimeErr}</span>}
                          </div>
                          <div className="w-full">
                            <Select
                              size="large"
                              placeholder="Select"
                              options={selectTime}
                              showSearch
                              filterOption={(input, selectTime) => (selectTime?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                              onChange={(value) => handleTimeChange(day, index, "closeTime", value)}
                              value={slot.closeTime}
                              className="w-[200px]"
                            />
                            {slot.closeTimeErr && <span className="text-red-100">{slot.closeTimeErr}</span>}
                          </div>
                          <div className="w-full">
                            <InputNumber
                              type="text"
                              size="large"
                              placeholder="Capacity"
                              className="w-[200px]"
                              maxLength={8}
                              onChange={(value) => {
                                handleTimeChange(day, index, "capacity", value);
                              }}
                              value={slot.capacity}
                            />
                            {slot.capacityErr && <span className="text-red-100">{slot.capacityErr}</span>}
                          </div>
                          {index === timeSlots[day]?.length - 1 ? (
                            <div className="w-full">
                              <Button icon={<PlusOutlined />} onClick={() => handleAddSlot(day)} />
                            </div>
                          ) : (
                            <div className="w-full">
                              <Button icon={<MinusOutlined />} onClick={() => handleRemoveSlot(day, index)} danger />
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                </Flex>
                <Divider className="mt-5" />
              </div>
            ))}
          </Form>
        </div>
        <Divider />
        <div className="flex justify-end gap-3">
          <Button onClick={() => goBack()}>Cancel</Button>
          <Button type="primary" htmlType="submit" onClick={() => handleSubmit()}>
            Save
          </Button>
        </div>
      </Card>
    </>
  );
};

export default EditBranchFastestHours;
